import React, { useMemo } from "react"
import { Box, Typography, Stack } from "@mui/material"
import dayjs from "dayjs"
import { styled } from "@mui/material/styles"
import NumberedProgressBar from "../../components/common/NumberedProgressBar"
import { getPECurrentActiveStep, getPEStepperOptions } from "../../utils/packagingExecutionUtils"
import { COLORS } from "../../utils"

const Container = styled(Box)({
	width: "100%",
	display: "flex",
	justifyContent: "space-between",
	alignItems: "center",
})

const Times = styled("span")({
	fontSize: 12,
	lineHeight: "18px",
})

const GreyText = styled(Times)({
	color: COLORS.PRODUCTION_STEPS_DISABLE_TEXT,
})

const TheoreticalTimeStrikeThrough = styled(Times)({
	textDecoration: "line-through",
	color: COLORS.PRODUCTION_STEPS_DISABLE_TEXT,
})

const CompletionLabel = styled("span")({
	fontSize: "16px",
	fontWeight: 500,
	lineHeight: "16px",
	color: COLORS.BLACK800,
})

const CompletionTime = styled("span")({
	color: COLORS.BLACK_500,
	fontSize: "16px",
	fontWeight: 500,
	lineHeight: "16px",
})

const Root = styled(Box)({
	marginTop: "8px",
	padding: "0 24px 16px 24px",
	borderBottom: "1px solid " + COLORS.PRIMARY_BORDER
})

const PEStepper = ({
	times = {},
	packagings = [],
	status,
	defaultCurrentStatus,
	withTitle = true
}) => {
	const { theoreticalStartTime, theoreticalEndTime, startTime, endTime } = times

	const completionTime = useMemo(() => {
		if (times.startTime && times.endTime) {
			return dayjs(times.endTime).diff(dayjs(times.startTime), "minutes")
		}
		if (times.theoreticalStartTime && times.theoreticalEndTime) {
			return dayjs(times.theoreticalEndTime).diff(dayjs(times.theoreticalStartTime), "minutes")
		}
		return undefined
	}, [times])

	return (
		<Root>
			{withTitle && (
				<Box marginBottom={3}>
					<Typography>
						<CompletionLabel>Déroulé de l'étape</CompletionLabel>
						{!isNaN(completionTime) && <CompletionTime> ( ~ {completionTime} minutes)</CompletionTime>}
					</Typography>
				</Box>
			)}
			<Container>
				<Stack direction="row" justifyContent="space-between" width={"100%"}>
					<Stack>
						<GreyText>Début</GreyText>
						{theoreticalStartTime && <TheoreticalTimeStrikeThrough style={startTime ? {} : { textDecoration: "none" }}>{dayjs(theoreticalStartTime).format("HH:mm")}</TheoreticalTimeStrikeThrough>}
						{startTime && <Times>{dayjs(startTime).format("HH:mm")}</Times>}
					</Stack>
					<NumberedProgressBar
						statusAndLabels={getPEStepperOptions(packagings).filter(option => option.value !== "BEFORE_START")}
						currentStatus={defaultCurrentStatus || getPECurrentActiveStep(status, packagings)}
						isCompleted={status === "DONE"}
					/>
					<Stack>
						<GreyText>Fin</GreyText>
						{theoreticalEndTime && <TheoreticalTimeStrikeThrough style={endTime ? {} : { textDecoration: "none" }}>{dayjs(theoreticalEndTime).format("HH:mm")}</TheoreticalTimeStrikeThrough>}
						{endTime && <Times>{dayjs(endTime).format("HH:mm")}</Times>}
					</Stack>
				</Stack>
			</Container>
		</Root>
	)
}

export default PEStepper
